<template>
  <base-modal
    class="examGradeModal"
    :hideFooter="true"
    headImgUrl="https://pandapub.nosdn.127.net/tmp1749112441_pfku_csvgmkrcujnfd43qw%3D%3D_2_1749108841_0.png"
    @close="handleClose"
    :title="title"
    >
    <div slot="content" class="examGradeModal_content">
      <template v-if="!loading">
        <template v-if="showGrade">
          <div class="examGradeModal_score">{{record.totalPoints / 10}}分</div>
          <!-- <div class="examGradeModal_btn" @click="goToDetail(info)">答案解析</div> -->
        </template>
        <div v-else class="examGradeModal_empty">未查询到考试成绩</div>
      </template>
      <div v-else class="examGradeModal_loading">加载中...</div>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/components/baseModal.vue';

export default {
  components: { baseModal },
  name: 'ExamGradeModal',
  props: {
    examId: Number,
    title: {
      type: String,
      default: '本次考试成绩'
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    showGrade() {
      return typeof this.record?.totalPoints === 'number';
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="less">
.examGradeModal {
  .base-modal_title {
    font-size: 24px;
    color: #1D2129;
    margin-top: 0;
    margin-bottom: 16px;
  }
  &_content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &_score {
    color: #FF6047;
    font-weight: 600;
    font-size: 40px;
    background: #F5F6F9;
    width: 362px;
    height: 102px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
  }
  &_btn {
    width: 240px;
    height: 48px;
    background: #E60012;
    border-radius: 24px;
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  &_empty {
    font-size: 20px;
    color: #1D2129;
    font-weight: bold;
  }
  &_loading {
    font-size: 20px;
  }
}
</style>

